<template>
  <div>
    <div class="display-flex justify-space-between align-center mb-5">
      <img
        @click="$router.push({ name: 'YouMobile' })"
        src="../../assets/mobile/icon/arrow-left.svg"
        width="9"
        height="18"
      />
      <img :src="require('@/assets/ys_logo_primary-black.svg')" width="100" />
      <div></div>
    </div>

    <Card />
  </div>
</template>

<script>
import Card from "./components/card.vue";

export default {
  components: {
    Card,
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// confirmation.vue?7a1db9cf